import React, {Component} from 'react'
import {Field} from 'redux-form';
import {renderFieldSelect} from '../../util/inputs';

export class BloqueioDescontoItinerario extends Component {

    adicionarTrechos(event) {
        event.preventDefault();
        this.props.adicionarTrechosBloqueioDesconto(this.props.trechoOrigemBloqueioDesconto, this.props.trechoDestinoBloqueioDesconto);
        this.props.changeFieldValue('formularioCadastroItinerario',
            'trechoOrigemBloqueioDesconto', null);
        this.props.changeFieldValue('formularioCadastroItinerario',
            'trechoDestinoBloqueioDesconto', null);
    }

    exibirTrechosSelecionados() {
        return <table className="table table-sm table-bordered">
            <thead>
            <tr className='text-center'>
                <th colSpan='3'>Trechos Bloqueados Desconto</th>
            </tr>
            <tr>
                <th>Origem</th>
                <th>Destino</th>
                <th/>
            </tr>
            </thead>
            <tbody>
            {!this.props.trechosBloqueioDescontoSelecionados || this.props.trechosBloqueioDescontoSelecionados.length === 0 ?
                <tr className="alert alert-warning text-center mt-4" role="alert">
                    <td colSpan='3'>Nenhum trecho foi bloqueado.</td>
                </tr>
                :
                this.props.trechosBloqueioDescontoSelecionados
                    .map((trecho) => <tr key={trecho.id}>
                        <td>
                            {trecho.origem.label}
                        </td>
                        <td>
                            {trecho.destino.label}
                        </td>
                        <td className='text-center' style={{cursor: 'pointer', color: 'red'}}>
                            <div
                                onClick={() => this.props.removerTrechoBloqueioDescontoSelecionado(trecho.origem.value, trecho.destino.value)}>Remover
                            </div>
                        </td>
                    </tr>)}
            </tbody>
        </table>
    }

    render() {
        return (
            <fieldset className="scheduler-border">
                <legend className="scheduler-border">Bloqueio de desconto em trechos</legend>
                <div className="col-12 col-sm-9 col-md-5">
                    <Field name='trechoOrigemBloqueioDesconto'
                           options={this.props.trechos.map(elemento => ({
                               descricao: elemento.cidadeDestino.nome,
                               nome: elemento.id
                           }))}
                           component={renderFieldSelect}
                           placeholder='Selecione o trecho de origem'/>
                </div>
                <div className="col-12 col-sm-9 col-md-5">
                    <Field name='trechoDestinoBloqueioDesconto'
                           options={this.props.trechos.map(elemento => ({
                               descricao: elemento.cidadeDestino.nome,
                               nome: elemento.id
                           }))}
                           component={renderFieldSelect}
                           placeholder='Selecione o trecho de destino'/>
                </div>
                <div className="col-12 col-sm-3 col-md-1">
                    <button
                        disabled={!this.props.trechoDestinoBloqueioDesconto || !this.props.trechoDestinoBloqueioDesconto}
                        type="submit" className="btn btn-sm btn-laranja"
                        onClick={(e) => this.adicionarTrechos(e)}>Incluir
                    </button>
                </div>
              <div className="col-12 col-sm-12 col-md-10 mt-2">
                <div className="lista-table">
                  {this.exibirTrechosSelecionados()}
                </div>
              </div>
            </fieldset>
        )
    }
}


export default BloqueioDescontoItinerario
